<template>
  <full-container>
    <div class="d-flex justify-space-around error-container">
      <div class="text-center pa-3 pa-md-10 ma-3">
        <h1 class="mb-6 font-title">
          Oops!
        </h1>
        <h3 class="mb-4 font-x-large">
          {{ title }}
        </h3>
        <p class="font-medium">
          {{ message }}
        </p>
        <router-link to="/">
          <base-button
            text="Home"
            class="mt-4"
          />
        </router-link>
      </div>
    </div>
  </full-container>
</template>

<script>
import { mapState } from 'vuex'
import { ERROR_TYPES } from '@/store/modules/error'
import FullContainer from '@/containers/full-container'

export default {
  name: 'Error',
  components: {
    FullContainer
  },
  computed: {
    ...mapState({
      error: state => state.error.error
    }),
    title () {
      let title = ''
      if (!this.error) {
        return title
      }
      switch (this.error.statusCode) {
      case 404:
        title = 'Page not found!'
        break
      case 401:
        title = 'Unauthorized'
        break
      default:
        title = 'Something went wrong!'
        break
      }
      return title
    },
    message () {
      if (process.env.VUE_APP_PRODUCTION !== 'true' && this.error) {
        if (this.error.message) {
          return this.error.message
        }
        return this.error
      }
      return 'We\'re sorry, an error has occurred and the page could not be loaded.\nIf this error persists, please contact the customer service team.'
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path !== from.path) {
      this.$store.commit(ERROR_TYPES.mutations.SET_ERROR, null)
    }
    next()
  }
}
</script>

<style lang="scss" scoped>
  .error-container {
    margin: 20vh 0;
  }

  p {
    white-space: pre-wrap;
    line-height: 1.8em;
  }
</style>
